var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.1174 7.62188L16.4459 0H14.9461L9.4512 6.61781L5.06221 0H0L6.63696 10.0074L0 18H1.49982L7.30286 11.0114L11.9378 18H17L10.117 7.62188H10.1174ZM8.06322 10.0955L7.39067 9.099L2.04017 1.16972H4.34379L8.66152 7.569L9.33393 8.56547L14.9468 16.8834H12.6435L8.06322 10.0959V10.0955Z",
    fill: "#B3CFEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.443740c95bcdef5126099d272f08c618.svg";
export { ForwardRef as ReactComponent };